<template>
    <div class="login_page">
        <div class="logo">
            <img src="../assets/img/school_logo.png" alt="">
            <div class="logo_name">
                <span>会议室预约系统</span>
                <br>
                <span>Conference Room Reservation System</span>
            </div>
        </div>
        <div class="login_box">
            <div class="title">{{title}}</div>
            <el-form ref="form" :model="account" v-if="pageType=='login'? true:false">
                <el-form-item>
                    <el-input v-model="account.username" placeholder="账号" prefix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="account.password" placeholder="密码" prefix-icon="el-icon-lock" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" class="login_btn">登录</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="text" class="forgetPwd_btn" icon="el-icon-question" @click="goForgetPwd">忘记密码？</el-button>
                </el-form-item>
            </el-form>
            <el-form ref="form" :model="forgetForm" v-if="pageType=='forgetPwd'? true:false">
                <el-form-item>
                    <el-input v-model="forgetForm.username" placeholder="账号" prefix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="forgetForm.email" placeholder="邮箱" prefix-icon="el-icon-message"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="text" class="forgetPwd_btn" icon="el-icon-link" @click="getEmailCode">获取验证码</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="forgetForm.email_code" placeholder="验证码" prefix-icon="el-icon-key"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="checkEmailCode" class="login_btn">提交</el-button>
                </el-form-item>
            </el-form>
            <el-form ref="form" :model="setPwdForm" v-if="pageType=='setPwd'? true:false">
                <el-form-item>
                    <el-input v-model="setPwdForm.pwd" placeholder="新密码" prefix-icon="el-icon-lock" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="setPwdForm.checkPwd" placeholder="确认密码" prefix-icon="el-icon-lock" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="setPwdHandle" class="login_btn">确认</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            account: {
                username: '',
                password: '',
            },
            pageType: null,
            title: '账号密码登录',
            forgetForm:{
                username: null,
                email: null,
                email_code: null
            },
            setPwdForm:{
                pwd: null,
                checkPwd: null
            }
        }
    },
    mounted(){
        if (this.$route.fullPath=='/login') {
            this.pageType = 'login'
            this.title = '账号密码登录'
        } else if (this.$route.fullPath=='/forgetPwd') {
            this.pageType = 'forgetPwd'
            this.title = '忘记密码'
        } else if (this.$route.fullPath=='/setPwd') {
            this.pageType = 'setPwd'
            this.title = '重设密码'
        }
    },
    methods: {
        onSubmit() {
            let url = '/login/'
            this.$axios.post(url, {
                username: this.account.username,
                password: this.account.password
            }).then(res => {
                if (res.access) {
                    const jwt = res.access
                    localStorage.setItem('jwt', jwt)
                    let userInfoJson = JSON.stringify(res.userInfo)
                    localStorage.setItem('userInfo', userInfoJson)
                    this.$store.state.islogin = true
                    this.$message.success('登录成功')
                    this.$router.push({path: '/'})
                }
            })
        },
        resetData(){
            if (this.$route.fullPath=='/login') {
                this.pageType = 'login'
                this.title = '账号密码登录'
            } else if (this.$route.fullPath=='/forgetPwd') {
                this.pageType = 'forgetPwd'
                this.title = '忘记密码'
            } else if (this.$route.fullPath=='/setPwd') {
                this.pageType = 'setPwd'
                this.title = '重设密码'
            }
        },
        goForgetPwd(){
            this.$router.push({path: '/forgetPwd'})
        },
        getEmailCode(){
            if (!this.forgetForm.username) {
                this.$message.error('账号不能为空')
                return false
            } else if (!this.forgetForm.email) {
                this.$message.error('邮箱不能为空')
                return false
            }
            this.$axios.post('/user/get_email_code/',{
                username: this.forgetForm.username,
                email: this.forgetForm.email
            })
            .then(res => {
                if (res.status === 1) {
                    this.$message.success('邮箱验证码已发送')
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        checkEmailCode(){
            if (!this.forgetForm.username) {
                this.$message.error('账号不能为空')
                return false
            } else if (!this.forgetForm.email) {
                this.$message.error('邮箱不能为空')
                return false
            } else if (!this.forgetForm.email_code) {
                this.$message.error('验证码不能为空')
                return false
            }
            this.$axios.post('/user/check_email/', this.forgetForm)
            .then(res => {
                if (res.status === 1) {
                    this.$message.success('验证成功')
                    localStorage.setItem('forgetForm', JSON.stringify(this.forgetForm))
                    this.$router.push({path: '/setPwd'})
                } else {
                    this.$message.error('验证失败')
                }
            })
        },
        setPwdHandle(){
            let forgetForm = JSON.parse(localStorage.getItem('forgetForm'))
            if (!this.setPwdForm.pwd) {
                this.$message.error('新密码不能为空')
                return false
            } else if (!this.setPwdForm.checkPwd) {
                this.$message.error('确认密码不能为空')
                return false
            } else if (this.setPwdForm.pwd != this.setPwdForm.checkPwd) {
                this.$message.error('两次密码不一致')
                return false
            }
            var assignObj = Object.assign(this.setPwdForm,forgetForm);
            this.$axios.post('/user/forget_pwd/',assignObj)
            .then(res => {
                if (res.status === 1) {
                    const jwt = res.access
                    localStorage.setItem('jwt', jwt)
                    let userInfoJson = JSON.stringify(res.data)
                    localStorage.setItem('userInfo', userInfoJson)
                    this.$store.state.islogin = true
                    this.$message.success('登录成功')
                    localStorage.removeItem('forgetForm')
                    this.$router.push({path: '/'})
                } else {
                    this.$message.error('重置密码失败')
                }
            })
        }
    },
    watch: {
        $route:{
            handler:'resetData',
        }
    },
}
</script>
<style lang="less" scoped>
.login_page{
    width: 100%;
    height: 100vh;
    background: url('../assets/img/school.jpg') no-repeat;
    background-size: 100% 100%;
    .logo{
        padding: 20px 5%;
        img{
            // width: 150px;
            height: 60px;
        }
        .logo_name{
            display: inline-block;
            padding-left: 48px;
            color: #09559D;
            border-left: 1px solid #09559D;
            text-align: left;
            margin-left: 30px;
            vertical-align: super;
            span:first-child{
                font-weight: bold;
            }
            span:last-child{
                margin-top: 4px;
                display: block;
            }
        }
    }
    .login_box{
        width: 300px;
        margin: 0 auto;
        background: rgba(0,0,0,0.5);
        border-radius: 10px;
        color: #ffffff;
        padding: 20px;
        margin-top: 5%;
        .title{
            font-size: large;
            text-align: center;
            margin-bottom: 20px;
        }
    }
}
</style>
<style lang="less">
.login_page .login_box .login_btn{
    width: 100%;
}
.login_page .login_box .forgetPwd_btn{
    
}
</style>